export const operationsEn = {
  "pos.exit.method": "Approval method",
  "pos.exit.scanQr": "Scan QR with phone",
  "pos.exit.usePassword": "Use password",
  "pos.exit.scanHint": "Scan with your phone camera. A signed-in club manager or platform admin can approve this exit.",
  "pos.exit.qrTitle": "Scan to approve this POS exit",
  "pos.exit.matchCode": "Match this code",
  "pos.exit.expires": "Valid for 2 minutes · one exit only",
  "pos.exit.waiting": "Waiting for approval on your phone…",
  "pos.exit.denied": "Exit declined. The POS screen stays locked.",
  "pos.exit.expired": "This QR code is no longer active. Request a new one at the POS.",
  "pos.exit.newQr": "Get a new QR code",
  "pos.exit.phoneTitle": "Approve POS exit",
  "pos.exit.signedInAs": "Signed in as {name}",
  "pos.exit.invalidQr": "This QR link is not valid. Scan a new code from the POS screen.",
  "pos.exit.confirmHint": "Check that the club, screen and six-digit code match the POS in front of you. Approving only exits POS mode on that screen; it does not sign your account into the terminal.",
  "pos.exit.deny": "Decline",
  "pos.exit.approve": "Approve this exit",
  "pos.exit.approved": "Approved. The POS screen will exit automatically. You can close this page.",
  "pos.exit.accountHint": "Use your ClubCore account. The account signed in on this screen is prefilled; change it if another manager is approving.",

  "pos.setup.command": "sudo ./install.sh",
  "pos.setup.repairDownload": "Download only (repair or update)",
  "pos.setup.installedVersion": "Agent {version}",
  "pos.setup.title": "Install a LAN agent",
  "pos.setup.intro": "Download once on an always-on Windows PC/server or Linux appliance at the club. No on-site ClubCore server is needed.",
  "pos.setup.step1": "Name the device and download its installer.",
  "pos.setup.step2": "Run the installer as administrator and paste the setup code below.",
  "pos.setup.step3": "The agent starts at boot. Approve discovered printers and assign them to outlets or kitchen stations.",
  "pos.setup.platform": "Install on",
  "pos.setup.windows": "Windows PC/server (64-bit)",
  "pos.setup.linux": "Linux appliance (systemd)",
  "pos.setup.downloadAndSetup": "Download installer & setup code",
  "pos.setup.unavailable": "This installer is temporarily unavailable. Contact your ClubCore administrator.",
  "pos.setup.version": "Agent {version} · {size} MB",
  "pos.setup.codeHint": "Use this code on one device before {expires}. It is shown only here; keep it private.",
  "pos.setup.code": "Setup code",
  "pos.setup.copy": "Copy setup code",
  "pos.setup.copied": "Copied",
  "pos.setup.downloadAgain": "Download again",
  "pos.setup.linuxCommand": "Extract the Linux download, then run:",
  "pos.setup.statusHint": "Printers and agent health update automatically. POS terminals report activity while the register or kitchen screen is open.",
  "pos.setup.checksum": "Download SHA-256",
  "pos.setup.manual": "Advanced: manual agent credential",
  "pos.setup.pending": "Awaiting installation",
  "pos.setup.expired": "Setup code expired",
  "pos.mode.lock": "Lock to POS",
  "pos.mode.unlock": "Exit POS mode",
  "pos.mode.managerHint":
    "A club manager or platform admin must approve this exit. Scan with your phone or use your ClubCore password.",
  "pos.mode.managerRequired":
    "A club manager or platform admin must approve leaving POS mode.",
  "apiError.pos_manager_required":
    "A club manager or platform admin must approve leaving POS mode.",
  "pos.nav.kitchen": "Kitchen",
  "pos.nav.devices": "Devices & printing",
  "pos.ops.originalTicket": "Original ticket details",
  "pos.ops.notRecorded": "Not recorded",
  "pos.ops.server": "Server: {server}",
  "pos.ops.unassigned": "Unassigned",
  "pos.ops.contextUpdated": "Table or server updated. Original ticket details remain in history.",
  "pos.ops.course": "Course {course}",
  "pos.ops.kitchen": "Kitchen display",
  "pos.ops.kitchenHint":
    "Live tickets for this station. Changes refresh automatically.",
  "pos.ops.station": "Station",
  "pos.ops.chooseStation": "Choose a station",
  "pos.ops.noStations": "No kitchen stations configured",
  "pos.ops.noStationsHint":
    "Create a station under Devices & printing and choose which items it receives.",
  "pos.ops.noTickets": "No active tickets",
  "pos.ops.check": "Check {number}",
  "pos.ops.table": "Table {table}",
  "pos.ops.seat": "Seat {seat}",
  "pos.ops.void": "VOID",
  "pos.ops.queued": "Queued",
  "pos.ops.preparing": "Preparing",
  "pos.ops.ready": "Ready",
  "pos.ops.completed": "Completed",
  "pos.ops.cancelled": "Cancelled",
  "pos.ops.start": "Start preparing",
  "pos.ops.markReady": "Mark ready",
  "pos.ops.complete": "Complete",
  "pos.ops.devices": "Devices & printing",
  "pos.ops.devicesHint":
    "Connect a local ClubCore agent, approve discovered printers, then map them to outlets and kitchen stations.",
  "pos.ops.agents": "LAN agents",
  "pos.ops.agentName": "Agent name",
  "pos.ops.enrol": "Create agent credential",
  "pos.ops.tokenHint":
    "Copy this credential now. It is shown only once. Store it on the local agent, never on a POS terminal.",
  "pos.ops.revoke": "Revoke agent",
  "pos.ops.revokeConfirm":
    "Revoke this agent? Its printers will stop receiving jobs until another agent is configured.",
  "pos.ops.noAgents":
    "No local agent connected. Hosted ClubCore needs an always-on LAN device for automatic printing and discovery.",
  "pos.ops.lastSeen": "Last seen",
  "pos.ops.never": "Never connected",
  "pos.ops.stale": "Not reporting",
  "pos.ops.online": "Online",
  "pos.ops.offline": "Offline",
  "pos.ops.revoked": "Revoked",
  "pos.ops.printers": "Discovered printers",
  "pos.ops.deviceKey": "Local device key",
  "pos.ops.printersHint":
    "Discovery does not enable printing. Approve a printer, then assign it below. Printers without discovery support can be configured on the agent.",
  "pos.ops.noPrinters": "No printers reported yet",
  "pos.ops.discoveryOnly": "Discovery only",
  "pos.ops.protocolHint":
    "Printing supports ESC/POS RAW 9100 printers and Windows RAW queues. IPP/LPD devices are shown for inventory only.",
  "pos.ops.approve": "Approve printer",
  "pos.ops.disable": "Disable printer",
  "pos.ops.terminals": "Terminal status",
  "pos.ops.noTerminals": "No terminals have reported yet",
  "pos.ops.stations": "Kitchen stations & templates",
  "pos.ops.newStation": "New station",
  "pos.ops.editStation": "Edit station",
  "pos.ops.name": "Name",
  "pos.ops.outlet": "Outlet",
  "pos.ops.active": "Active",
  "pos.ops.printer": "Printer",
  "pos.ops.noPrinter": "No automatic printing",
  "pos.ops.categories": "Route categories",
  "pos.ops.categoriesHint":
    "No selection routes every category. Item types still apply.",
  "pos.ops.itemTypes": "Route item types",
  "pos.ops.columns": "Kitchen columns",
  "pos.ops.fontSize": "Kitchen text size (px)",
  "pos.ops.warningMinutes": "Highlight after (minutes)",
  "pos.ops.showNotes": "Show kitchen notes",
  "pos.ops.header": "Printed header",
  "pos.ops.footer": "Printed footer",
  "pos.ops.paperWidth": "Paper width",
  "pos.ops.paperMillimeters": "{width} mm",
  "pos.ops.showPrices": "Print prices",
  "pos.ops.showSignature": "Print signature line",
  "pos.ops.receipts": "Outlet receipt printing",
  "pos.ops.receiptsHint":
    "Automatically queue a receipt when a check is settled. Kitchen tickets are queued when items are sent.",
  "pos.ops.jobs": "Print queue",
  "pos.ops.noJobs": "No print jobs",
  "pos.ops.claimed": "Sending",
  "pos.ops.printed": "Delivered to printer",
  "pos.ops.uncertain": "Check printer",
  "pos.ops.retry": "Reprint after checking",
  "pos.ops.resolvePrinted": "Confirm already printed",
  "pos.ops.resolveCancelled": "Cancel this print job",
  "pos.ops.resolveHint":
    "Record what you found at the printer. This resolves the job without sending it again.",
  "pos.ops.reason": "Resolution reason",
  "pos.ops.retryConfirm":
    "Check the printer first. Reprinting may produce a duplicate if the original job printed without an acknowledgement. Queue another attempt?",
  "pos.ops.kind.kitchen": "Kitchen ticket",
  "pos.ops.kind.receipt": "Receipt",
  "pos.ops.kind.void": "Void notice",
  "pos.ops.saved": "Saved",
  "pos.printers.search": "Find a printer",
  "pos.printers.group.production": "Kitchen & receipt printers",
  "pos.printers.group.office": "Office & virtual printers",
  "pos.printers.group.unclassified": "Needs classification",
  "pos.printers.emptyGroup": "No printers in this group.",
  "pos.printers.purpose": "Intended use",
  "pos.printers.purposeFor": "Intended use for {name}",
  "pos.printers.purpose.kitchen": "Kitchen ticket",
  "pos.printers.purpose.receipt": "Guest receipt",
  "pos.printers.purpose.kitchen_receipt": "Kitchen & receipt",
  "pos.printers.purpose.office": "Office / document",
  "pos.printers.purpose.virtual": "Virtual printer",
  "pos.printers.purpose.unclassified": "Unclassified",
  "pos.printers.protocol.windows": "Windows queue",
  "pos.printers.protocol.raw": "RAW network printer",
  "pos.printers.protocol.inventory": "Inventory connection",
  "pos.printers.stale": "Status out of date",
  "pos.printers.unreachable": "Network unreachable",
  "pos.printers.queueAttention": "Queue reports a problem",
  "pos.printers.reachable": "Network reachable",
  "pos.printers.queueUnverified": "Queue ready · network unverified",
  "pos.printers.reportedAvailable": "Reported available",
  "pos.printers.suggested": "Suggested from device details",
  "pos.printers.assigned": "Assigned use",
  "pos.printers.configured": "Approved for routing",
  "pos.printers.notApproved": "Not approved",
  "pos.printers.outputBlocked": "Physical printing disabled",
  "pos.printers.outputEnabled": "Physical printing enabled",
  "pos.printers.held": "Held · printing disabled",
  "pos.printers.details": "Connection details",
  "pos.printers.driver": "Driver",
  "pos.printers.queueStatus": "Windows queue status",
  "pos.preview.title": "Kitchen routing preview",
  "pos.preview.hint": "Check a sample hot dish, cold dish, beverage and retail item. This creates no order, kitchen ticket or print job and never contacts a printer.",
  "pos.preview.run": "Preview routing · no printing",
  "pos.preview.hot": "Sample hot dish",
  "pos.preview.cold": "Sample cold dish",
  "pos.preview.drink": "Sample beverage",
  "pos.preview.retail": "Sample retail item",
  "pos.preview.missingCategories": "Create the Hot and Cold kitchen categories before running this shared-kitchen preview.",
  "pos.preview.noJobs": "Preview only · 0 print jobs created",
  "pos.preview.noRoutes": "No kitchen route matches this outlet.",
  "pos.preview.liveConfigured": "Live output is configured; this preview still sends nothing.",
  "pos.preview.unrouted": "Not routed to the kitchen: {lines}",
  "pos.preview.selectOutlet": "Choose an outlet",
  "pos.ops.originalCheck": "Original check #{number}",
  "pos.ops.splitTicket": "This ticket now serves more than one check. See each item’s destination.",
  "pos.ops.ticketDetails": "Ticket items and destinations",
  "pos.ops.portionPlacement": "{quantity} → Check #{number} · {table} · {server}",
  "pos.ops.portionVoid": "Voided quantity: {quantity}",
  "pos.ops.linePlacement": "Now check #{number} · Table {table} · {server}",
};
export type OperationsMessages = typeof operationsEn;
